import PublicHeader from "@/components/layout/PublicHeader";
import PublicFooter from "@/components/layout/PublicFooter";
import PartnersStrip from "@/components/salnes/PartnersStrip";
import Hero from "@/components/salnes/Hero";
import KpisWow from "@/components/salnes/KpisWow";
import ConcelloCards from "@/components/salnes/ConcelloCards";
import ComoFunciona from "@/components/salnes/ComoFunciona";
import MapSection from "@/components/salnes/MapSection";

export default function Landing() {
  return (
    <div className="min-h-screen bg-salnes-ivory">
      <PublicHeader />
      <main>
        <Hero />
        <KpisWow />
        <ConcelloCards />
        <ComoFunciona />
        <MapSection />
        <PartnersStrip />
      </main>
      <PublicFooter />
    </div>
  );
}
